import React, { useLayoutEffect } from "react";

import SSEClass from "../components/sseprogram/sseprogram";
import Footer from "../components/footer/footer";
import SathyaSaiMenu from "../components/navbarmenu/navmenu";
import Banner from "../components/banner/banner";
import BottomBanner from "../components/bottombanner/bottombanner";
import Menucardforallpage from "../components/menucardforallpage/menucardforallpage";
import Sai100Gal from "../components/sai100gal/sai100gal";


function Sai100GalleryPage() {
  useLayoutEffect(() => {
      document.title = 'SAI Gallery - Sri Sathya Sai Center of Milwaukee | ssscmke.org';
  }, []);
  return (
    <div className="SSE">
        <SathyaSaiMenu />
        <Banner title="Sai 100 Gallery" pic="/images/sse-Banner.png"/>
        <Sai100Gal />
        <Menucardforallpage page="sse" />
        <BottomBanner />
        <Footer />
    </div>
  );
}
export default Sai100GalleryPage;
